import * as React from "react";
import { Selectors } from "@grandvisionhq/auth";
import { useSelector } from "@grandvisionhq/state";
import { getServiceStore, shouldCreateAccount } from "../../../../selectors.js";
import { isShippingStepValid } from "../../../StepShipping/selectors.js";
import { useCheckoutSettings } from "../../../../context/CheckoutSettings/context/CheckoutSettings/context.js";
const useShippingStepValidation = () => {
  const checkoutSettings = useCheckoutSettings();
  const isServiceStoreEnabled = checkoutSettings.features?.isServiceStoreEnabled;
  const isCreateAccountRequired = Boolean(
    checkoutSettings.account?.implicitAccountCreation || checkoutSettings.account?.createAccountRequired
  );
  const isLoggedIn = useSelector(Selectors.isLoggedIn);
  const isShippingStepValidBoolean = useSelector(isShippingStepValid);
  const selectedServiceStore = useSelector(getServiceStore);
  const shouldCreateAccountBoolean = useSelector(shouldCreateAccount);
  const isStepShippingValid = React.useCallback(() => {
    const haveValidServiceStore = !isServiceStoreEnabled || !!selectedServiceStore || isServiceStoreEnabled && Boolean(checkoutSettings.serviceStore?.isOptional);
    const haveValidAccount = isLoggedIn || !isCreateAccountRequired || shouldCreateAccountBoolean;
    return isShippingStepValidBoolean && haveValidServiceStore && haveValidAccount;
  }, [
    checkoutSettings.serviceStore?.isOptional,
    isCreateAccountRequired,
    isLoggedIn,
    isServiceStoreEnabled,
    isShippingStepValidBoolean,
    selectedServiceStore,
    shouldCreateAccountBoolean
  ]);
  return React.useMemo(
    () => ({
      isStepShippingValid
    }),
    [isStepShippingValid]
  );
};
export {
  useShippingStepValidation
};
//# sourceMappingURL=use-shipping-step-validation.js.map
